import { useMutation, UseMutateAsyncFunction } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { AddAttachmentRequestParams, AddAttachmentResponse } from 'api';
import { API_HANDLERS } from 'api/apiHandlers';

interface UseUploadAttachmentReturn {
  isVideoLoading: boolean;
  uploadVideoAttachmentMutation: UseMutateAsyncFunction<
    AxiosResponse<AddAttachmentResponse, unknown>,
    unknown,
    AddAttachmentRequestParams,
    unknown
  >;
}

export function useVideoUploadAttachment(): UseUploadAttachmentReturn {
  const { mutateAsync: uploadVideoAttachmentMutation, isLoading: isVideoLoading } = useMutation(
    API_HANDLERS.FILES.VIDEO_UPLOAD,
  );

  return { isVideoLoading, uploadVideoAttachmentMutation };
}
